import '../inbox_content_view.js.coffee';# Added by Script 
import '../social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.InstagramStoryMentionMessageView extends
Monitoring.Views.SocialContents.InboxContentView

  _renderAttachments: ->
    stories = @model.getAttachments()
    @attachmentsView = new Monitoring.Views.SocialContents.SocialContentAttachmentsView
      instagramStories: stories
      instagramStoriesAreExpired: @model.get('content').message.storiesAreExpired()
      useVideoIcon: stories[0].type == Common.AttachmentType.VIDEO
    @$el.find('.sc-text').append(@attachmentsView.render().el)

  _showAttachmentsBox: ->
    true
